import React from "react";
import Header from "@/components/Header";
import SEO from "@/components/SEO";
import Footer from "@/components/Footer";
import { EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#FFF1E5]">
      <SEO title="Contact Us" description="Get in touch with the Farmwatch team - advertising, news tips, listings support and general enquiries." url="/contact" />
      <Header />
      
      <main className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Page Header */}
        <div className="text-center mb-12">
          <span className="px-2 py-1 bg-[#0F766E] text-white text-xs font-mono uppercase tracking-wider">
            Contact
          </span>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#33302E] mt-4 mb-4">
            Get in Touch
          </h1>
          <p className="text-[#6B6661] text-lg max-w-md mx-auto">
            Have a question, story tip, or partnership inquiry? We'd love to hear from you.
          </p>
        </div>

        {/* Contact Card */}
        <div className="bg-white border border-[#E0D4C8] p-8 sm:p-12 text-center">
          <div className="w-16 h-16 bg-[#0F766E] rounded-full flex items-center justify-center mx-auto mb-6">
            <EnvelopeSimple size={32} className="text-white" />
          </div>
          
          <h2 className="font-serif text-2xl text-[#33302E] mb-2">
            Email Us
          </h2>
          <p className="text-[#6B6661] mb-6">
            For all inquiries, reach out to our team at:
          </p>
          
          <a 
            href="mailto:grow@farmwatch.com"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#022C22] text-white font-medium text-lg hover:bg-[#064E3B] transition-colors"
            data-testid="contact-email-link"
          >
            <EnvelopeSimple size={24} weight="bold" />
            grow@farmwatch.com
          </a>
          
          <p className="text-sm text-[#6B6661] mt-6">
            We aim to respond within 24-48 hours
          </p>
        </div>

        {/* Additional Info */}
        <div className="grid sm:grid-cols-2 gap-6 mt-8">
          <div className="bg-white border border-[#E0D4C8] p-6">
            <div className="flex items-center gap-3 mb-3">
              <Clock size={20} className="text-[#0F766E]" />
              <h3 className="font-medium text-[#33302E]">Response Time</h3>
            </div>
            <p className="text-sm text-[#6B6661]">
              Our team typically responds within 1-2 business days. For urgent matters, please include "URGENT" in your subject line.
            </p>
          </div>
          
          <div className="bg-white border border-[#E0D4C8] p-6">
            <div className="flex items-center gap-3 mb-3">
              <MapPin size={20} className="text-[#0F766E]" />
              <h3 className="font-medium text-[#33302E]">Coverage</h3>
            </div>
            <p className="text-sm text-[#6B6661]">
              Farmwatch covers agricultural markets across Ireland, UK, USA, Brazil, France, and beyond.
            </p>
          </div>
        </div>

        {/* What We Cover */}
        <div className="bg-[#022C22] p-8 mt-8 text-center">
          <h3 className="font-serif text-xl text-white mb-4">What can we help with?</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              { label: "News Tips", email: "news@farmwatch.com", subject: "News Tip Submission" },
              { label: "Advertising", email: "grow@farmwatch.com", subject: "Advertising Inquiry" },
              { label: "Partnerships", email: "grow@farmwatch.com", subject: "Partnership Inquiry" },
              { label: "Feedback", email: "grow@farmwatch.com", subject: "Feedback" },
              { label: "Technical Support", email: "support@farmwatch.com", subject: "Technical Support Request" },
              { label: "Press Inquiries", email: "grow@farmwatch.com", subject: "Press Inquiry" }
            ].map((item) => (
              <a 
                key={item.label}
                href={`mailto:${item.email}?subject=${encodeURIComponent(item.subject)}`}
                className="px-4 py-2 bg-[#064E3B] text-[#6EE7B7] text-sm hover:bg-[#065F46] transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
